<template>
    <div v-if="loaded" class="CountDown-content" :class="expired ? 'expired' : ''">
        <svg
            v-svg
            symbol="Timer"
            size="0 0 24 24"
            role="presentation"
            class="icon--inline Icon-Timer"
        ></svg>
        <div 
            v-if="!expired"
        >
            Créneau valable pendant  : {{ displayHours }}h : {{ displayMinutes }} : {{ displaySeconds }}
        </div>
        
        <div 
            v-else-if="expired"
        >
                Ce créneau n'est plus valable
        </div>
        <div v-else class="no-content"></div>

    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default{
    name: "CountDown",

    data() {
        return {
            displayDays: 0,
            displayHours: 0,
            displayMinutes: 0,
            displaySeconds: 0,
            countDownDateStarted: "",
            timer: null,
            expired: false,
            loaded: false,
            now: 0,
            endTime: 0,
            serverTime: "",
            countDownDuration: 7200000
        };
    },

    computed: {
        _second: () => 1000,
        _minutes() {
            return this._second * 60;
        },
        _hours() {
            return this._minutes * 60;
        },

        ...mapGetters({
            startTime: "getUpdateDateForSlotSelectDelivery",
            currentTime: "getServerDateNow"
        })
    },

    watch: {
        
        //Need to watch startTime to update countDownDateStarted when response from getUpdateDateForSlotSelectDelivery (Cart and Checkout)
        startTime() {
            this.countDownDateStarted = this.startTime;
        },

        countDownDateStarted() {
            this.$emit("restartCountDown");
            /* this.setCurrentTime(); */
            this.setEndTime(this.startTime);
            this.clearTimer();

            this.showRemainingTime(); 
        },

        //Need to watch currentTime to update this.now with currentTime on FP return
        currentTime() {
            this.setCurrentTime();
            this.showRemainingTime();
        },

    },

    mounted() {
        this.countDownDateStarted = this.startTime;
        this.setCurrentTime();
        this.setEndTime(this.startTime);
        this.getServerTime();
        this.tabFocusEvent();
    },

    beforeDestroy() {
        // prevent memory leak
        this.clearTimer();
    },

    methods: {
        formatTime: (num) => (num < 10 ? '0' + num : num),

        setEndTime(startedDate) {
            // 2h = 7200000ms
            /* OLD VERTION (issue on firefox) : this.endTime = Date.parse(new Date(startedDate)) + 7200000; */
            this.endTime = Date.parse(this.$dayjs.utc(startedDate)) + this.countDownDuration;
        },

        setCurrentTime() {
            if(this.currentTime != "") {
                this.now = Date.parse(this.currentTime); 
            }

            if(this.endTime - this.now > this.countDownDuration ) {
                this.now -= (this.endTime - this.now) - this.countDownDuration
            } 
        },

        setCountDownExpired() {
            this.expired = true;
            this.$emit("CountDownExpired");
            this.setDeliveryDateAvailability(false);
            this.loaded = true;
            return
        },

        clearTimer() {  
            if(window.timer != null) {
                clearInterval(window.timer);
            }
        },

        createTimer(endDate) {

            if(this.endTime - this.now > this.countDownDuration ) {
                this.now -= (this.endTime - this.now) - this.countDownDuration
               }
            
            window.timer = setInterval(() => {
               
                const distance = endDate - this.now;

                //CountDown Expired 
                if (distance < 0) {
                    clearInterval(window.timer);
                    this.setCountDownExpired()
                    return
                }

                //Get Hours, Minutes and seconds
                const hours = Math.floor(distance / this._hours);
                const minutes = Math.floor((distance % this._hours) / this._minutes);
                const seconds = Math.floor((distance % this._minutes) / this._second);

                //Format and asign
                this.displayMinutes = this.formatTime(minutes);
                this.displaySeconds = this.formatTime(seconds);
                this.displayHours = this.formatTime(hours);

                //Display Countdow when ready
                this.expired = false;
                this.loaded = true;


                //Increment startTime to get the current server time 1000ms
                this.now += 1000;
            }, 1000)
        },

        showRemainingTime() {

            if(this.endTime - this.now > 0) {
                this.setDeliveryDateAvailability(true);
                this.clearTimer(); // Clear previous timer
                
                if(this.now > 0) {
                    this.createTimer(this.endTime);
                }
                
            } else if(this.endTime - this.now <= 0) {
                this.setCountDownExpired()
            }
        },

        getServerTime() {
            let xmlHttp;

                try {
                //FF, Opera, Safari, Chrome
                xmlHttp = new XMLHttpRequest();
                }
                catch (err1) {
                    //IE
                    try {
                        xmlHttp = new ActiveXObject('Msxml2.XMLHTTP');
                    }
                    catch (err2) {
                        try {
                            xmlHttp = new ActiveXObject('Microsoft.XMLHTTP');
                        }
                        catch (eerr3) {
                            console.error("AJAX not supported");
                        }
                    }
                }
                xmlHttp.open('HEAD', process.env.VUE_APP_API_BASE_URL+"/mcp/config/dummy",false);
                xmlHttp.setRequestHeader("Content-Type", "text/html");
                xmlHttp.send('');

                this.setDateFromServer(xmlHttp.getResponseHeader("Date"))
                this.currentTime = xmlHttp.getResponseHeader("Date")
        },

        tabFocusEvent() {
            document.addEventListener('visibilitychange', (ev) => {
                if (document.visibilityState === 'visible') {
                    this.getServerTime();
                }
            });
        },

        ...mapActions(["setDeliveryDateAvailability"]),
        ...mapActions(["setDateFromServer"]),
    },
}
</script>

<style lang="scss">
    .CountDown-content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        padding: 10px;
        color: #34a853;
        border: 1px solid #34a853;
        border-radius: 10px;

        .Icon-Timer{
            position: relative;
            fill: #34a853;
            height: 20px;
            margin-right: 10px;
        }

        @media ($mq-phone) {
            flex-direction: column;
            margin-left: 0px;
        }
        
        @media ($mq-desktop) {
            &>div{
                height: 15px;
            }
        }
    }

    .CountDown-content.expired {
        color: $color-orange;
        border-color: $color-orange;
        font-weight: 600;

        .Icon-Timer{
            fill: $color-orange;
        }
    }

    .CountDown-content .no-content {
        background: url(../../assets/icons/zeborne/Timer.svg);
        background: url(../../assets/icons/mcp/Timer.svg);
        opacity: 0;
    }
</style>